module.exports = "/public/images/57a0bc53a2e9947c7039f772705dd343.png";